import React, { Fragment } from 'react';
import { useStore } from 'modules/Stores';
import { observer } from 'mobx-react';
import OptionChainModal from '../OptionChainModal/OptionChainModal';

const OptionChainModalContainer = () => {
  const {
    modalsConfig: { optionChain },
  } = useStore('AppStore');

  return optionChain ? (
    <OptionChainModal />
  ) : (
    <Fragment />
  );
};

export default observer(OptionChainModalContainer);
